import { render, staticRenderFns } from "./NewEndorsementApplication.vue?vue&type=template&id=0ea93ddd"
import script from "./NewEndorsementApplication.vue?vue&type=script&lang=ts"
export * from "./NewEndorsementApplication.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports